import { render, staticRenderFns } from "./DateIsWeekday.vue?vue&type=template&id=0c40f4ac&scoped=true"
import script from "./DateIsWeekday.vue?vue&type=script&lang=js"
export * from "./DateIsWeekday.vue?vue&type=script&lang=js"
import style0 from "./DateIsWeekday.vue?vue&type=style&index=0&id=0c40f4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40f4ac",
  null
  
)

export default component.exports